export const translation = {
  zenit: {
    ae: {
      siteTitle: 'مكافآتك | Zenit',
      bonusTitle: `مكافأة ترحيبية`,
      step1: 'سجّل',
      step2: 'أودع',
      step3: 'استمتع بالمقامرة',
      getBtn: 'احصل على مكافأة',
      rulesBtn: 'الشروط والأحكام',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    bn: {
      siteTitle: 'আপনার বোনাস | Zenit',
      bonusTitle: `স্বাগত বোনাস`,
      step1: 'নিবন্ধন করুন',
      step2: 'জমা করুন',
      step3: 'জুয়া উপভোগ করুন',
      getBtn: 'বোনাস পান',
      rulesBtn: 'শর্তাবলী',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    br: {
      siteTitle: 'Seus bônus | Zenit',
      bonusTitle: `BÔNUS
        DE BOAS-VINDAS`,
      step1: 'Registre-se',
      step2: 'Faça depósitos',
      step3: 'Desfrute das apostas',
      getBtn: 'Obtenha um bônus',
      rulesBtn: 'TERMOS E CONDIÇÕES',
      regFormTitle: `REGISTRE-SE
        E OBTENHA UM BÔNUS!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    de: {
      siteTitle: 'Ihre Boni | Zenit',
      bonusTitle: `WILLKOMMENSBONUS`,
      step1: 'Registrieren',
      step2: 'Einzahlen',
      step3: 'Spielen',
      getBtn: 'Bonus erhalten',
      rulesBtn: 'ALLGEMEINE GESCHÄFTSBEDINGUNGEN',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    en: {
      siteTitle: 'Your bonuses | Zenit',
      bonusTitle: 'Welcome bonus',
      step1: 'Register',
      step2: 'Make deposits',
      step3: 'Enjoy gambling',
      getBtn: 'Get bonus',
      rulesBtn: 'Terms and conditions',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    fr: {
      siteTitle: 'Vos bonus | Zenit',
      bonusTitle: `BONUS
        DE BIENVENUE`,
      step1: `S'enregistrer`,
      step2: `Effectuer des\xA0dépôts`,
      step3: `S'amuser à\xA0parier`,
      getBtn: 'Obtenir un bonus',
      rulesBtn: 'CONDITIONS GÉNÉRALES',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    ir: {
      siteTitle: 'پاداش خوش‌آمدگویی | بنگاه شرط‌بندی ZENIT',
      bonusTitle: 'پاداش خوش‌آمدگویی',
      step1: 'ثبت‌نام',
      step2: 'انجام واریز',
      step3: 'از بازی لذت ببرید',
      getBtn: 'دریافت پاداش',
      rulesBtn: 'شرایط و ضوابط',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    kz: {
      siteTitle: 'Сенің бонустарың | БК Зенит',
      bonusTitle: 'Welcome bonus',
      step1: 'Тіркел',
      step2: 'Шотты толықтыру',
      step3: 'Ойыннан ләззат алыңыз',
      getBtn: 'Бонусты алу',
      rulesBtn: 'ЕРЕЖЕЛЕР',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`,
      footnoteText: '*подробнее в Правилах',
    },
    mx: {
      siteTitle: 'Sus bonificaciones | Zenit',
      bonusTitle: `BONO
       DE BIENVENIDA`,
      step1: 'Registrar',
      step2: 'Hacer depósitos',
      step3: `Disfrute del\xA0juego`,
      getBtn: 'Obtenga una bonificación',
      rulesBtn: 'TÉRMINOS Y CONDICIONES',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    ru: {
      siteTitle20: 'Стартовый бонус до 20 000 | ZENIT',
      siteTitle25: 'Стартовый бонус 25 000 р | БК ZENIT',
      bonusTitle: 'Welcome bonus',
      step1: 'Регистрируйся',
      step2: 'Пополняй счет',
      step3: 'Наслаждайся игрой',
      getBtn: 'Забрать бонус',
      rulesBtn: 'Правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`,
      footnoteText: '*подробнее в Правилах',
    },
    sw: {
      siteTitle: 'Bonasi zako | Zenit',
      bonusTitle: `KUBALI BONASI`,
      step1: 'Jisajili',
      step2: 'Weka pesa',
      step3: 'Furahia kucheza kamari',
      getBtn: 'Pokea bonasi',
      rulesBtn: 'SHERIA NA MASHARTI',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    tr: {
      siteTitle: 'Bonuslarınız | Zenit',
      bonusTitle: `HOŞ GELDİN BONUSU`,
      step1: 'Kaydolun',
      step2: 'Para yatırın',
      step3: 'Kumar oynamanın keyfini çıkarın',
      getBtn: 'Bonus al',
      rulesBtn: 'HÜKÜM VE KOŞULLAR',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    uz: {
      siteTitle: 'Bonuslaring | Zenit',
      bonusTitle: `WELCOME BONUSI`,
      step1: 'Ro‘yxatdan o‘t',
      step2: 'Hisobni to‘ldir',
      step3: 'O‘yindan lazzatlan',
      getBtn: 'Bonus olish',
      rulesBtn: 'QOIDALAR',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*подробнее в Правилах',
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | Zenit',
      bonusTitle: `THƯỞNG
        CHÀO MỪNG`,
      step1: 'Đăng ký',
      step2: 'Nạp tiền',
      step3: 'Tận hưởng hoạt động đánh bạc',
      getBtn: 'Nhận tiền thưởng',
      rulesBtn: 'ĐIỀU KHOẢN VÀ ĐIỀU KIỆN',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    }
  },
  zenbet: {
    ae: {
      siteTitle: 'مكافآتك | ZENBET',
      bonusTitle: `مكافأة ترحيبية`,
      step1: 'سجّل',
      step2: 'أودع',
      step3: 'استمتع بالمقامرة',
      getBtn: 'احصل على مكافأة',
      rulesBtn: 'الشروط والأحكام',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    bn: {
      siteTitle: 'আপনার বোনাস | ZENBET',
      bonusTitle: `স্বাগত বোনাস`,
      step1: 'নিবন্ধন করুন',
      step2: 'জমা করুন',
      step3: 'জুয়া উপভোগ করুন',
      getBtn: 'বোনাস পান',
      rulesBtn: 'শর্তাবলী',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    br: {
      siteTitle: 'Seus bônus | ZENBET',
      bonusTitle: `BÔNUS
      DE BOAS-VINDAS`,
      step1: 'Registre-se',
      step2: 'Faça depósitos',
      step3: 'Desfrute das apostas',
      getBtn: 'Obtenha um bônus',
      rulesBtn: 'TERMOS E CONDIÇÕES',
      regFormTitle: `REGISTRE-SE
        E OBTENHA UM BÔNUS!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    de: {
      siteTitle: 'Ihre Boni | ZENBET',
      bonusTitle: `WILLKOMMENSBONUS`,
      step1: 'Registrieren',
      step2: 'Einzahlen',
      step3: 'Spielen',
      getBtn: 'Bonus erhalten',
      rulesBtn: 'ALLGEMEINE GESCHÄFTSBEDINGUNGEN',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    en: {
      siteTitle: 'Your bonuses | ZENBET',
      bonusTitle: 'Welcome bonus',
      step1: 'Register',
      step2: 'Make deposits',
      step3: 'Enjoy gambling',
      getBtn: 'Get bonus',
      rulesBtn: 'Terms and conditions',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    fr: {
      siteTitle: 'Vos bonus | ZENBET',
      bonusTitle: `BONUS
        DE BIENVENUE`,
      step1: `S'enregistrer`,
      step2: `Effectuer des\xA0dépôts`,
      step3: `S'amuser à\xA0parier`,
      getBtn: 'Obtenir un bonus',
      rulesBtn: 'CONDITIONS GÉNÉRALES',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    ir: {
      siteTitle: 'پاداش خوش‌آمدگویی | بنگاه شرط‌بندی ZENBET',
      bonusTitle: 'پاداش خوش‌آمدگویی',
      step1: 'ثبت‌نام',
      step2: 'انجام واریز',
      step3: 'از بازی لذت ببرید',
      getBtn: 'دریافت پاداش',
      rulesBtn: 'شرایط و ضوابط',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    kz: {
      siteTitle: 'Сенің бонустарың | БК ZENBET',
      bonusTitle: 'Welcome bonus',
      step1: 'Тіркел',
      step2: 'Шотты толықтыру',
      step3: 'Ойыннан ләззат алыңыз',
      getBtn: 'Бонусты алу',
      rulesBtn: 'ЕРЕЖЕЛЕР',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`,
      footnoteText: '*подробнее в Правилах',
    },
    mx: {
      siteTitle: 'Sus bonificaciones | ZENBET',
      bonusTitle: `BONO
       DE BIENVENIDA`,
      step1: 'Registrar',
      step2: 'Hacer depósitos',
      step3: `Disfrute del\xA0juego`,
      getBtn: 'Obtenga una bonificación',
      rulesBtn: 'TÉRMINOS Y CONDICIONES',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    ru: {
      siteTitle: 'Твои бонусы | БК ZENBET',
      bonusTitle: 'Welcome bonus',
      step1: 'Регистрируйся',
      step2: 'Пополняй счет',
      step3: 'Наслаждайся игрой',
      getBtn: 'Забрать бонус',
      rulesBtn: 'Правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`,
      footnoteText: '*подробнее в Правилах',
    },
    sw: {
      siteTitle: 'Bonasi zako | ZENBET',
      bonusTitle: `KUBALI BONASI`,
      step1: 'Jisajili',
      step2: 'Weka pesa',
      step3: 'Furahia kucheza kamari',
      getBtn: 'Pokea bonasi',
      rulesBtn: 'SHERIA NA MASHARTI',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    tr: {
      siteTitle: 'Bonuslarınız | ZENBET',
      bonusTitle: `HOŞ GELDİN BONUSU`,
      step1: 'Kaydolun',
      step2: 'Para yatırın',
      step3: 'Kumar oynamanın keyfini çıkarın',
      getBtn: 'Bonus al',
      rulesBtn: 'HÜKÜM VE KOŞULLAR',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    },
    uz: {
      siteTitle: 'Bonuslaring | ZENBET',
      bonusTitle: `WELCOME BONUSI`,
      step1: 'Ro‘yxatdan o‘t',
      step2: 'Hisobni to‘ldir',
      step3: 'O‘yindan lazzatlan',
      getBtn: 'Bonus olish',
      rulesBtn: 'QOIDALAR',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*подробнее в Правилах',
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | ZENBET',
      bonusTitle: `THƯỞNG
        CHÀO MỪNG`,
      step1: 'Đăng ký',
      step2: 'Nạp tiền',
      step3: 'Tận hưởng hoạt động đánh bạc',
      getBtn: 'Nhận tiền thưởng',
      rulesBtn: 'ĐIỀU KHOẢN VÀ ĐIỀU KIỆN',
      regFormTitle: `Register
        and get the bonus!`,
      footnoteText: '*read more in Terms and Conditions of the Promotion',
    }
  }
}
